import React, { useContext, useState } from "react";
import { ChildrenProps } from "../customTypes/valueTypes";
import { IAvailableCreatedBy, IAvailableEscalation, IAvailableEscalationStatus, IEscalatedPageDetailModel, IEscalationStatusesCount, IPaginationDetailModel } from "../Models/escalatedPageModels";
import { DEFAULT_ESCALATION_STATUS_COUNT, PAGINATION } from "../Pages/escalatedPage/escalatedPage.constants";
import { ISortObj } from "../Models/applicationModels";

const EscalationInfoContext = React.createContext<EscalationInfoPayload | null>(null);

export interface EscalationInfoPayload {
    escalatedData: IEscalatedPageDetailModel[] | null;
    setEscalatedData: React.Dispatch<React.SetStateAction<IEscalatedPageDetailModel[] | null>>;
    escalationList: IAvailableEscalation[] | null;
    setEscalationList: React.Dispatch<React.SetStateAction<IAvailableEscalation[] | null>>;
    escalationStatusList: IAvailableEscalationStatus[] | null;
    setEscalationStatusList: React.Dispatch<React.SetStateAction<IAvailableEscalationStatus[] | null>>;
    paginationDetail: IPaginationDetailModel;
    setPaginationDetail: React.Dispatch<React.SetStateAction<IPaginationDetailModel>>;
    createdByList: IAvailableCreatedBy[];
    setCreatedByList: React.Dispatch<React.SetStateAction<IAvailableCreatedBy[]>>;
    escalationStatusesCount: IEscalationStatusesCount[];
    setEscalationStatusesCount: React.Dispatch<React.SetStateAction<IEscalationStatusesCount[]>>;
    totalEscalationsCount: number;
    setTotalEscalationsCount: React.Dispatch<React.SetStateAction<number>>;
    searchValue: string | null;
    setSearchValue: React.Dispatch<React.SetStateAction<string | null>>;
    sortInfo: ISortObj | null;
    setSortInfo: React.Dispatch<React.SetStateAction<ISortObj | null>>;
    flagUpdateEscalation: boolean;
    setFlagUpdateEscalation: React.Dispatch<React.SetStateAction<boolean>>;
}

const EscalationInfoProvider = ({ children }: ChildrenProps) => {

    const [escalatedData, setEscalatedData] = useState<IEscalatedPageDetailModel[] | null>(null)
    const [escalationList, setEscalationList] = useState<IAvailableEscalation[] | null>(null);
    const [escalationStatusList, setEscalationStatusList] = useState<IAvailableEscalationStatus[] | null>(null);
    const [paginationDetail, setPaginationDetail] = useState<IPaginationDetailModel>({
        count: 0,
        rowsPerPage: PAGINATION.DEFAULT_ROWS_PER_PAGE,
        page: 0
    });
    const [createdByList, setCreatedByList] = useState<IAvailableCreatedBy[]>([]);
    const [escalationStatusesCount, setEscalationStatusesCount] = useState<IEscalationStatusesCount[]>(DEFAULT_ESCALATION_STATUS_COUNT);
    const [totalEscalationsCount, setTotalEscalationsCount] = useState<number>(0);
    const [searchValue, setSearchValue] = useState<string | null>(null);
    const [sortInfo, setSortInfo] = useState<ISortObj | null>(null);
    const [flagUpdateEscalation, setFlagUpdateEscalation] = useState<boolean>(false);
    const payload: EscalationInfoPayload = {
        escalatedData,
        setEscalatedData,
        escalationList,
        setEscalationList,
        escalationStatusList,
        setEscalationStatusList,
        paginationDetail,
        setPaginationDetail,
        createdByList,
        setCreatedByList,
        escalationStatusesCount,
        setEscalationStatusesCount,
        totalEscalationsCount,
        setTotalEscalationsCount,
        searchValue,
        setSearchValue,
        sortInfo,
        setSortInfo,
        flagUpdateEscalation,
        setFlagUpdateEscalation
    };

    return (
        <EscalationInfoContext.Provider value={payload}>
            {children}
        </EscalationInfoContext.Provider>
    )
}

const useEscalationInfo = (): EscalationInfoPayload => {
    const context = useContext(EscalationInfoContext);
    if (!context) {
        throw new Error("useEscalationInfo must be used within a EscalationInfoContext");
    }
    return context;
};

export { EscalationInfoContext, EscalationInfoProvider, useEscalationInfo };
